/*
 * @Author: your name
 * @Date: 2022-02-07 15:23:26
 * @LastEditTime: 2023-12-27 11:37:13
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsySelectCheckBox\index.jsx
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';

import { BsyWidget } from '../BsyWidget';
import './index.css'

export default class BsyDeptPane extends BsyWidget {

    constructor(props) {
        super({

            waterMark: null,
            textField: "name",
            valueField: "_id",
            onStopEdit: null,
            limit: {},
            ...props
        });
        this.state = {
            ...this.state,

        }
        this.element = React.createRef()

    }


    componentDidMount() {
        super.componentDidMount();

        this.loadData(0, () => {
            if (this.state.items.length)
                this.props.onStopEdit && this.props.onStopEdit(this.state.items[0], !0)
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {

        if (this.state.value !== nextProps.value) {
            this.setState({
                value: nextProps.value,
            }, () => {

            })
        }


    }

    transformToTreeFormat = (b) => {
        let simpleData = {
            enable: true,
            idKey: "departmentId",
            pIdKey: "parentId"
        }
        var c, d, e = simpleData.idKey, f = simpleData.pIdKey, g = 'children';
        if (!e || "" == e || !b)
            return [];
        if (Array.isArray(b)) {
            var h = []
                , i = [];
            for (c = 0, d = b.length; c < d; c++) {
                i[b[c][e]] = b[c];
            }

            for (c = 0, d = b.length; c < d; c++) {

                if (i[b[c][f]] && b[c][e] != b[c][f]) {
                    i[b[c][f]][g] || (i[b[c][f]][g] = [])


                    b[c].title = b[c].name;
                    b[c].key = b[c].departmentId;
                    i[b[c][f]][g].push(b[c])
                } else {
                    b[c].title = b[c].name;
                    b[c].key = b[c].departmentId;
                    h.push(b[c])
                }

            }
            return h
        }
        b.title = b.name;
        b.key = b.departmentId;
        return [b]
    }

    loadData = (skip, cb) => {

        if (!BsyUtils.isObjectEmpty(this.G_Departments)) {

            this.setState({
                items: [...this.G_Departments],
                value: this.G_Departments[0]._id,
            }, () => {
                cb && cb()
            })
            return
        }

        React.axios('/corp/department/list', {
            appId: this.APPID
        }).then(res => {
            BsyUtils.showAjaxTip(res.data, () => {
                let dd = this.transformToTreeFormat(res.data['departments'])

                dd[0].open = true;
                //当前页面有多个部门筛选条件请求的时候，临时缓存，减少不必要的请求
                this.G_Departments = [...dd];

                this.setState({
                    items: dd,
                    value: this.G_Departments[0]._id,
                }, () => {
                    cb && cb()
                })
            })

        }).catch(res => {
            console.error(res);
            this.setState({
                items: [],
            }, () => {
                cb && cb()
            })
        })
    }

    selectItem = (val) => {
        return (e) => {
            this.props.onStopEdit && this.props.onStopEdit(val)
        }
    }

    renderChildNode = (data, index) => {
        const { textField, valueField } = this.options
        const { value } = this.state;
        return (<>
            {
                data && data.map((val) => {
                    let selected = val.selected;
                    let classNames = ''

                    if (val.fixed) {

                        return <div key={val[valueField]} className={'item bsy-x-check fixed'} >
                            <i className={val.icon}></i>
                            <span>
                                {
                                    val[textField]
                                }
                            </span>
                        </div>
                    }


                    selected = value === val[valueField];
                    classNames = selected ? "item select " : "item "



                    if (val.hasOwnProperty('corpId'))
                        classNames = classNames + ' csp-' + index;

                    if (val.hasOwnProperty('corpId')) {
                        return <div key={val[valueField]} className={(val.open ? "expand" : '') + '  pid-' + val._id} >
                            <div
                                title={val[textField]}
                                onClick={this.selectItem(val)} className={classNames}>
                                {
                                    //折叠
                                    val.hasOwnProperty('corpId') && val.children && val.children.length > 0 ? <i
                                        onClick={(e) => {
                                            let tag = this.element.current.querySelector('.pid-' + val._id)
                                            if (tag) {
                                                if (tag.classList.contains('expand')) {
                                                    tag.classList.remove('expand')
                                                    if (tag.querySelector('.children'))
                                                        tag.querySelector('.children').style.display = 'none'
                                                    if (tag.querySelector('.open')) {
                                                        tag.querySelector('.open').classList.remove('icon-tree-collapse')
                                                        tag.querySelector('.open').classList.add('icon-tree-expand')
                                                    }
                                                } else {
                                                    tag.classList.add('expand')
                                                    if (tag.querySelector('.children'))
                                                        tag.querySelector('.children').style.display = ''
                                                    if (tag.querySelector('.open')) {
                                                        tag.querySelector('.open').classList.add('icon-tree-collapse')
                                                        tag.querySelector('.open').classList.remove('icon-tree-expand')
                                                    }
                                                }
                                            }
                                            e.stopPropagation();
                                        }}

                                        className={val.open ? " open icon-tree-collapse" : " open icon-tree-expand"}></i> : <i className='blank'></i>
                                }

                                {
                                    //部门标识
                                    val.hasOwnProperty('corpId') && <i className="icon-dept-title"></i>
                                }
                                <span>
                                    {
                                        val[textField]
                                    }
                                </span>

                            </div>
                            {
                                val.children && <div className={'children'}
                                    style={{
                                        display: val.open ? '' : 'none'
                                    }}
                                >
                                    {
                                        this.renderChildNode(val.children, index + 1)
                                    }
                                </div>
                            }
                        </div>
                    }
                    return <div key={val[valueField]}
                        title={val[textField]}
                        onClick={this.selectItem(val)} className={classNames}>

                        <span>
                            {
                                val[textField]
                            }
                        </span>

                    </div>

                })
            }
        </>)
    }

    renderDD = () => {
        const { items } = this.state

        if (items) {

            return this.renderChildNode(items, 0)

        }
        return <></>
    }

    render() {

        return <div className={'bsy-dept-select-pane'} ref={this.element} >{this.renderDD()}</div>
    }

}
